import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Validators, FormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { AppRouterService } from 'src/app/core/services/app-router.service';
import { SessionService } from 'src/app/core/services/session.service';
import { AuthenticationService } from '../services/authentication.service';
import { ToastController, LoadingController, IonRouterOutlet, ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { HelperService } from 'src/app/core/services/helper.service';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { MultiFactorComponent } from 'src/app/shared/modals/multi-factor/multi-factor.component';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType, InteractionType, AccountInfo, SsoSilentRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { PublicClientApplication, IPublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
// import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  loginform: UntypedFormGroup;
  password = true;
  showLoginTryHere: boolean;
  loginError: boolean;
  attemptLogin: any;
  loginDisplay = false;
  isIframe = false;
  isAccess:boolean;
  private readonly _destroying$ = new Subject<void>();


  constructor(
    private title: Title,
    private fb: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private sessionService: SessionService,
    private appRouter: AppRouterService,
    public toastController: ToastController,
    public loadingController: LoadingController,
    public storage: Storage,
    public router: Router,
    public helperService: HelperService,
    private backendService: BackendService,
    private modalCtrl: ModalController,
    private routerOutlet: IonRouterOutlet,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private http: HttpClient,
  ) {
    this.authService.initialize();
  }
  storageObject;
  ngOnInit(): void {
    this.http.get('assets/feature_switching.json').subscribe((res: any) => {
      this.isAccess = res.microsoft_login;
    })
    this.title.setTitle('eZintegrations | Login');
    this.password = true;
    this.loginform = this.fb.group({
      'email': ['', Validators.required],
      'password': ['', Validators.required],
      'remember': [false],
      'is_sso': [false],
      'code': []
    });
    this.getAllSystemConfig()
    this.getStorage().then((res) => {
      this.storageObject = res.token;
      if (this.storageObject != null) {
        this.appRouter.gotoPath('baseapp');
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.helperService.dismissToast();
      }
    });
    this.isIframe = window !== window.parent && !window.opener;
    this.setLoginDisplay();
 
    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        } else {
          this.setLoginDisplay();
        }
      });
   
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      })
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  async isLogout() {
    return new Promise((resolve) => {
      const currentUser = this.authService.instance.getAllAccounts()
      const userInfo: any = this.authService.instance.getAllAccounts()
      //console.log("isLogout - ", currentUser)
      const SsoSilentRequest = {
        loginHint: userInfo.user // I have added my static mail id which i used to login in application1
      }

      //===========================
      // //console.log("currentUser",currentUser)
      // const currentAccount = this.authService.instance.getAccountByHomeId(currentUser[0].homeAccountId);
      // Extract login hint to use as logout hint
      // const logoutHint = currentAccount.idTokenClaims.login_hint;
      // this.authService.instance.logoutPopup({ logoutHint: logoutHint });
      //===========================

      this.authService.instance.ssoSilent(SsoSilentRequest).then((res: any) => {
        // Automatically on page load
        this.authService.instance.logoutRedirect({
          onRedirectNavigate: () => {
            // const currentAccount = this.authService.instance.getAccountByHomeId(res.account.homeAccountId)
            const logoutHint = res.account.idTokenClaims.login_hint;
            this.authService.instance.logoutPopup({ logoutHint: logoutHint });
            // this.authService.instance.setActiveAccount(null);
            resolve(true)
            // Return false to stop navigation after local logout
            return false;
          }
        });
        //console.log("SsoSilentRequestLogout - ", res)
      }).catch(error => {
        console.error("Silent Error: " + error);
      });
    })
  }


  async checkMSALLogedIn() {
    const activeAccount = await this.authService.instance.getAllAccounts();
    if (activeAccount.length > 0) {
      this.isLogout().then((data) => {
        if (data) {
          //console.log("loged out - ", this.authService.instance.getAllAccounts())
          setTimeout(() => { this.loginPopup() }, 1000)
        }
      })
    } else {
      this.loginPopup()
    }
  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          // this.authService.instance.setActiveAccount(response.account);
          //console.log("loginPopup", response.account)
          let profileInfo: any = response.account
          let loginConfig: any = {
            "email": profileInfo.username,
            "is_sso": true,
            "remember": false
          }
          this.authenticationService.login(loginConfig)
            .subscribe(
              async data => {
                //console.log("LoginResponse - ", data);
                if (!data.isPwdExpired) {
                  if (data && data.token) {
                    // data.isPwdExpired = true;
                    // let decoded_token = JSON.parse(atob(data.token.split('.')[1]));
                    let decoded_token
                    await this.helperService.decode(data.token).then((d)=>{decoded_token=d})
                    this.helperService.roleId = decoded_token.role.role_id;
                    this.helperService.freeTrialMode = data.free_trial_mode
                    this.sessionService.setStorageDetails(data, this.loginform.value.remember);
                    this.appRouter.gotoPath('baseapp');
                  }
                  if (data && data.msg) {
                    this.helperService.presentToast(data.msg, 2000);
                    return;
                  }
                } else {
                  this.sessionService.setStorageDetails("resetPwd", this.loginform.value.remember, data);
                  this.router.navigate(['reset-password']);
                }
              },
              err => {
                //console.log(err);
                if (err.error.detail == 'MFA code is required for this user') {
                  this.openSchedular();
                }
                if (err.error.isTrusted) {
                  this.helperService.presentToastWithButton("Try again");
                } else {
                  this.helperService.presentToastWithButton(err.error.detail);
                }
              }
            );
        });
    } else {
      this.authService.loginPopup().subscribe((response: AuthenticationResult) => {
        this.authService.instance.setActiveAccount(response.account);
      });
    }
  }

  // logout(popup?: boolean) {
  //   if (popup) {
  //     this.authService.logoutPopup({
  //       mainWindowRedirectUri: "/"
  //     });
  //   } else {
  //     this.authService.logoutRedirect();
  //   }
  // }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  ionViewWillEnter() {
    this.getAllSystemConfig()
  }

  getAllSystemConfig() {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getAllConfig', 'gyfvg').subscribe(
        (data) => {
          //console.log(data[0].id, data[0])
          if (data[0].id === 1 && data[0].config_name === "SHOW_REGISTER") {
            this.showLoginTryHere = data[0].config_value == "1"; // Set showLoginTryHere based on config_value
            //console.log("showLoginTryHere:", this.showLoginTryHere);
          }
          this.helperService.closeLoader();
        },
        err => {
          //console.log(err);
          this.helperService.closeLoader();
          this.helperService.presentToast(err.error.detail, 2000);
        }
      );
    });
  }

  get f() { return this.loginform.controls; }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  async onSubmitlogin(code?) {
    if (this.loginform.invalid) {
      return;
    }
    this.loginform.patchValue({
      email: this.loginform.value.email.trim(),
      password: this.loginform.value.password.trim(),
      is_sso: false,
      code: code
    })
    const payload={
      email:this.loginform.value.email,
      password: await this.helperService.encrypt(this.loginform.value.password),
      is_sso:this.loginform.value.is_sso,
      code:code
    }
    this.authenticationService.login(payload).subscribe(async data => {
      //console.log("data", data);
      if (!data.isPwdExpired) {
        if (data && data.token) {
          // data.isPwdExpired = true;
          // let decoded_token = JSON.parse(atob(data.token.split('.')[1]));
          // await this.helperService.encode(data.token).then((en)=>{
          //   this.storage.set('token1',en);
          // })
          let decoded_token
          await this.helperService.decode(data.token).then((d)=>{decoded_token=d})
          this.helperService.roleId = decoded_token.role.role_id;
          this.helperService.freeTrialMode = data.free_trial_mode
          this.sessionService.setStorageDetails(data, this.loginform.value.remember);
          this.appRouter.gotoPath('baseapp');

        }
        if (data && data.msg) {
          this.helperService.presentToast(data.msg, 2000);
          return;
        }
      } else {
        this.sessionService.setStorageDetails("resetPwd", this.loginform.value.remember, data);
        this.router.navigate(['reset-password']);
      }

    },
      err => {
        //console.log(err);
        if (err.error.detail == 'MFA code is required for this user') {
          this.helperService.presentToastWithButton(err.error.detail);
          this.openSchedular();
        }
        else if (err.error.isTrusted) {
          this.helperService.presentToastWithButton("Try again");
        }
        else {
          if (err.error.detail.attemptsLeft >= 0) {
            this.loginError = true;
          this.helperService.presentToastWithButton(err.error.detail.msg);
          this.attemptLogin = err.error.detail.attemptsLeft;
          } else {
            this.loginError = false;
            this.helperService.presentToastWithButton(err.error.detail);
          }
        }

      }
    );


  }


  async openSchedular() {
    // let data = this.summary.controls["schedule"].value;
    const modal = await this.modalCtrl.create({
      component: MultiFactorComponent,
      componentProps: {
        "Data": "mfa"
      },
      cssClass: 'my-custom-class',
      swipeToClose: true,
      backdropDismiss: true,
      presentingElement: this.routerOutlet.nativeEl
    });
    modal.onDidDismiss().then(async res => {
      if (res != undefined && res != null) {
        await this.onSubmitlogin(res.data.otp)
      }
    })
    return await modal.present();
  }
}
